import Image from 'next/image'
import { createLogger } from '@/lib/logger'
import type { Media } from '@/payload-types'

const logger = createLogger('Logo.tsx', { showStacktrace: true })

type LogoProps = React.HTMLAttributes<HTMLDivElement> & {
  url?: string | null
  icon?: Media | null
  alt: string
  size?: number
  sizes?: string
  fill?: boolean
  priority?: boolean
  loading?: 'eager' | 'lazy'
}

export default function Logo({
  url,
  icon,
  alt,
  size,
  sizes,
  fill,
  style,
  className,
  priority,
  loading,
}: LogoProps) {
  if (typeof icon === 'number') {
    logger.error(`Icon should not be a number:`, icon)
    return null
  }

  const src = icon && typeof icon === 'object' ? icon : undefined
  const imageSrc = url || src?.url

  if (imageSrc) {
    return (
      <Image
        src={imageSrc}
        alt={alt}
        sizes={sizes}
        width={size}
        height={size}
        className={className}
        style={style}
        {...(fill ? { fill: true } : {})}
        {...(priority ? { priority: true } : loading ? { loading } : {})}
      />
    )
  }
}
